import React, { useState } from "react";
import { Input, Drawer, Button, message } from "antd";
import { useSavePrompt } from "./hooks/useSavePrompt";

const EditDrawer = ({ showEditDrawer, editableVersion, setShowEditDrawer, selectedPrompt }) => {

  const [editTitle, setEditTitle] = useState(selectedPrompt ? selectedPrompt.title : '');
  const [editPrompt, setEditPrompt] = useState(editableVersion ? editableVersion.prompt : '');
  const [versionNotes, setVersionNotes] = useState(editableVersion ? editableVersion.version_notes : '');

  React.useEffect(() => {
    setEditTitle(selectedPrompt ? selectedPrompt.title : '');
    setEditPrompt(editableVersion ? editableVersion.prompt : '');
    setVersionNotes(editableVersion ? editableVersion.version_notes : '');
  }, [editableVersion, selectedPrompt, showEditDrawer]);

  const handleEditClose = () => {
    setShowEditDrawer(false);
    setEditTitle('');
    setEditPrompt('');
    setVersionNotes('');
  }

  const mutation = useSavePrompt({});

  const handleSave = () => {
    if (!editTitle || !editPrompt || !versionNotes) {
      message.error('All fields are required. Please fill in the title, prompt, and version notes.');
      return;
    }

    const payload = {
      title: editTitle,
      prompt: editPrompt,
      id: selectedPrompt ? selectedPrompt.id : null,
      version_notes: versionNotes
    };

    mutation.mutateAsync(payload, {
      onSuccess: () => {
        handleEditClose();
      },
    });
  };

  return (
    <Drawer
      title={`${editableVersion ? 'Edit' : 'Create' } System Prompt`}
      placement='left'
      width={750}
      closable={true}
      onClose={handleEditClose}
      open={showEditDrawer}
      destroyOnHidden={true}
      footer={
        <div style={{ justifyContent: 'flex-end', gap: 8, display: 'flex' }}>
          <Button onClick={handleEditClose}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleSave}
            loading={mutation.isLoading}
            disabled={mutation.isLoading}
          >
            Save
          </Button>
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div>
          <Input
            value={editTitle}
            onChange={(e) => setEditTitle(e.target.value)}
            placeholder="Title"
            style={{ marginBottom: 8 }}
          />
        </div>
        <div style={{ flex: 1, height: '100%', marginBottom: 16 }}>
          <Input.TextArea
            value={editPrompt}
            onChange={e => setEditPrompt(e.target.value)}
            placeholder="Enter system instructions for the agent…"
            rows={20}
            style={{ marginBottom: 8, height: '100%' }}
          />
        </div>
        <div>
          <Input.TextArea
            value={versionNotes}
            onChange={e => setVersionNotes(e.target.value)}
            placeholder="Describe the changes in this version"
            rows={3}
            maxLength={500}
            style={{ marginBottom: 8 }}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default EditDrawer;
